import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { deleteApp } from "../../api";

export default function DeleteAppModal({ serverCode, appName }) {
  const { toast, closeModal } = useUI();
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { ok, data } = await deleteApp(serverCode, appName);
      if (ok) {
        toast(data.message || "Đã xoá app", "ok");
        closeModal();
      } else {
        toast(data.message || "Lỗi server", "err");
      }
    } catch {
      toast("Không kết nối được BackendNode", "err");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div style={{
        background: "var(--red-soft)",
        border: "1px solid var(--red)",
        borderRadius: "10px",
        padding: "12px 14px",
        color: "var(--red)",
        fontSize: "13px",
        lineHeight: "1.5",
      }}>
        Bạn chắc chắn muốn xoá <strong>{appName}</strong> khỏi giám sát của <strong>{serverCode}</strong>? Agent sẽ ngừng theo dõi tiến trình này.
      </div>

      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal} disabled={busy}>
          Huỷ
        </button>
        <button className="mbtn mbtn-danger" onClick={submit} disabled={busy}>
          {busy ? "Đang xoá…" : "✕ Xoá"}
        </button>
      </div>
    </div>
  );
}
